class Accordion {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {

    // 初期画像を設定
    $(".main-image").attr("src", $(".accordion-title").first().data("image"));

    // アコーディオンタイトルがクリックされた時の処理
    $(".accordion-title").click(function () {
      // 現在クリックされたタイトルの次の要素（コンテンツ）
      var content = $(this).next(".accordion-content");
      var newImage = $(this).data("image"); // クリックされたタイトルに対応する画像を取得

      // すでに開いている他のコンテンツを閉じて、is-activeクラスを削除
      $(".accordion-content").not(content).slideUp();
      $(".accordion-title").not($(this)).removeClass("is-active");

      // クリックされたタイトルに対応するコンテンツをトグル（開閉）し、is-activeクラスをトグル
      content.slideToggle();
      $(this).toggleClass("is-active");

      // 画像を切り替え
      if ($(this).hasClass("is-active")) {
        $(".main-image").attr("src", newImage);
      }
    });
  }
}




